'use client';

import ClientFehlerSeite from '../../../../../src/components/fehlerseite/ClientFehlerSeite';

/**
 * Fehlerseite der Server-Seiten (Startseite, Landingpages), wenn die SEITE
 * scheitert — Texte der SEO-Verwaltung oder das Wörterbuch nicht abrufbar,
 * oder das Bündel der App nicht ladbar (Gast mit ungültiger Kombination,
 * angemeldeter Besuch). Scheitert das LAYOUT darüber (Sprach-Matrix des
 * Backends nicht erreichbar), greift `app/global-error.tsx`: Eine
 * `error.tsx` fängt nie das Layout ihres eigenen Segments.
 */
export default function Fehler({ error }: { error: Error & { digest?: string } }) {
  return <ClientFehlerSeite error={error} />;
}
